import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Dialog, withMobileDialog } from '@material-ui/core';
import DialogTemplate from 'components/shared/DialogTemplate';
import BankIdLogin from 'modules/users/containers/bankid-login';

const BankIdLoginDialog = ({ fullScreen, header, title, open, onClose, onSuccess, footer }) => {
  return (
    <Dialog fullScreen={fullScreen} fullWidth maxWidth="md" open={open}>
      <DialogTemplate
        title={header}
        isNew={false}
        pristine={false}
        onClose={onClose}
        onSave={null}
        isUpdating={false}
      >
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="body1" component="p">
              {title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <BankIdLogin onSuccess={onSuccess} />
          </Grid>
        </Grid>
        {footer}
      </DialogTemplate>
    </Dialog>
  );
};

BankIdLoginDialog.propTypes = {
  open: PropTypes.bool,
  header: PropTypes.node,
  title: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  footer: PropTypes.node,
};

export default withMobileDialog()(BankIdLoginDialog);
